type Ilce = {
  ilce: string;
  mahalleler: string[];
};

type Il = {
  il: string;
  ilceler: Ilce[];
};

let loadPromise: Promise<Il[]> | null = null;

function loadTurkey(): Promise<Il[]> {
  if (!loadPromise) {
    loadPromise = import('@/data/turkey_location.json').then((mod) => {
      const data = (mod as { default?: Il[] }).default ?? (mod as unknown as Il[]);
      return Array.isArray(data) ? data : [];
    });
  }
  return loadPromise;
}

export async function listTurkeyCities(): Promise<string[]> {
  const data = await loadTurkey();
  return [...new Set(data.map((province) => province.il))];
}

export async function listTurkeyDistricts(city: string): Promise<string[]> {
  const data = await loadTurkey();
  const found = data.find((province) => province.il === city);
  return found ? found.ilceler.map((ilce) => ilce.ilce) : [];
}

export async function listTurkeyNeighborhoods(city: string, district: string): Promise<string[]> {
  const data = await loadTurkey();
  const foundCity = data.find((province) => province.il === city);
  const foundDistrict = foundCity?.ilceler.find((ilce) => ilce.ilce === district);
  return foundDistrict?.mahalleler ?? [];
}
